<template>
  
  <v-container fluid grid-list-md align-start>
      <v-layout row wrap align-start justify-start>
        <v-flex xs12>
              <p class="text-sm-center headline">Over hundreds of 5 star reviews - the simplest way to remove the PayPal button on Shopify</p>
              <p class="text-sm-center title">Send us an email at  <a href="mailto:support@inscoder.com">support@inscoder.com</a> if you need an assistance with setup.</p>
        </v-flex>        

        <v-flex xs6>
          <v-flex>
            <v-card dark color="primary">
              <v-card-text class="px-3">A. Shopping Cart Page | Drawer Cart | Mini Cart </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-card-media
                src="https://cdn.shopify.com/s/files/1/1710/7463/files/cart-screen-1.png?10002560682932921174"
                height="300px"
              ></v-card-media>

              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">A. Hide paypal button</h3>
                  <div>from shopping cart page, drawer cart, and mini cart</div>
                  <br>
                  <div v-show="(hideCartButton === false)">You have not yet enable this feature.  To start hiding paypal button from these places, click the <b>Enable</b> button.  After it is enabled, please wait a few minutes to let it become effective.</div>
                  <div v-show="(hideCartButton === true)">The paypal button is now hidden from your shopping cart page
                    <p></p>
                    <p>Do the followings for best performance</p>
                    <p>1. Go to Online Store -> Themes</p>
                    <p>2. Edit theme.liquid file <a href="https://shopify.com/admin/themes/current/?key=layout/theme.liquid" target="_blank">(Click here to open)</a></p>
                    <p>3. Locate the &lt;/head&gt; tag and paste the code snippet before this tag.</p>
                    <code>&lt;script&gt;eval(localStorage.inscoderhidepaypalcartexecute)&lt;/script&gt;</code>
                    <p></p><!--
                    <p>Tips: Read our <router-link to="faq">FAQ Page</router-link> if you see an error message: Analytics snippet does not look valid (UA-xxxx-x)</p>
                    <p></p>
                    <video width="100%" controls>
                        <source src="@/assets/cartbutton-instructions-mp4.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>-->
                    <p></p>
                    <p>To start showing the paypal button once again, click the <b>Disable</b> button</p>
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>                
                <v-btn v-show="(hideCartButton === false)" large block outline color="primary" @click="updateCartButton('on')" :loading="loading"
      :disabled="loading">Enable</v-btn>
                <v-btn v-show="(hideCartButton === true)" large block outline color="red" @click="updateCartButton('off')" :loading="loading"
      :disabled="loading">Disable</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex xs6>
          <v-flex>
            <v-card dark color="primary">
              <v-card-text class="px-3">B. Customer Information Checkout page </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-card-media
                src="https://cdn.shopify.com/s/files/1/1710/7463/files/checkout-screen-1.png?16094608636233350059"
                height="300px"
              ></v-card-media>

              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">B. Hide paypal button</h3>
                  <div>from customer information checkout page</div>
                  <br>
                  <div v-show="(hideCheckoutButton === false)">You have not yet enable this feature.  To start hiding paypal button from these places, click the <b>Enable</b> button.  After it is enabled, please wait a few minutes to let it become effective.</div>
                  <div v-show="(hideCheckoutButton === true)">You have enabled this feature.
                    <v-alert :value="true" type="warning">
                      Hiding script does not work with cart popups for some of the themes.
                      <br><br>

                      Is the PayPal button still showing on customer information checkout page?
                      <br><br>

                      If you're using a mini cart that slides or pops out in your theme, you'll need to go to Online Store -> Themes -> Customize and set your cart type to "Page" (or ask your theme developer to do this).  You can also <a href="https://inscoder.com/contact-page/" target="+blank">hire us</a> at US$20 (per theme)

                    </v-alert>
                    <p></p>
                    <p>In the future if you switch to a new theme, please refresh by clicking <b>Disable</b> button and <b>Enable</b> button</p>
                    <p></p>
                    <p>To start showing the paypal button once again, click the <b>Disable</b> button</p>
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>                
                <v-btn v-show="(hideCheckoutButton === false)" large block outline color="primary" @click="updateCheckoutButton('on')" :loading="loading2"
      :disabled="loading2">Enable</v-btn>
                <v-btn v-show="(hideCheckoutButton === true)" large block outline color="red" @click="updateCheckoutButton('off')" :loading="loading2"
      :disabled="loading2">Disable</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex xs6>
          <v-flex>
            <v-card dark color="primary">
              <v-card-text class="px-3">C. Product - Dynamic Checkout Button</v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-card-media
                src="https://cdn.shopify.com/s/files/1/1710/7463/files/product-screen-3.png?2173721288995737546"
                contain="true"
                height="700px"
              ></v-card-media>

              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">C. Hide paypal button</h3>
                  <div>from product grid dynamic checkout button</div>
                  <br>
                  <div v-show="(hideProductButton === false)">You have not yet enable this feature.  To start hiding paypal button from these places, click the <b>Enable</b> button.  After it is enabled, please wait a few minutes to let it become effective.</div>
                  <div v-show="(hideProductButton === true)">The paypal button is now hidden from your shopping cart page
                    <p></p>
                    <p>Do the followings for best performance</p>
                    <p>1. Go to Online Store -> Themes</p>
                    <p>2. Edit theme.liquid file <a href="https://shopify.com/admin/themes/current/?key=layout/theme.liquid" target="_blank">(Click here to open)</a></p>
                    <p>3. Locate the &lt;/head&gt; tag and paste the code snippet before this tag.</p>
                    <code>&lt;script&gt;eval(localStorage.inscoderhidepaypalproductexecute)&lt;/script&gt;</code>
<!--
                    <p></p>
                    <p>Tips: Read our <router-link to="faq">FAQ Page</router-link> if you see an error message: Analytics snippet does not look valid (UA-xxxx-x)</p>
                    <p></p>
                    <video width="100%" controls>
                        <source src="@/assets/cartbutton-instructions-mp4.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
-->
                    <p></p>
                    
                    <p>To start showing the paypal button once again, click the <b>Disable</b> button</p>
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-btn v-show="(hideProductButton === false)" large block outline color="primary" @click="updateProductButton('on')" :loading="loading3"
      :disabled="loading3">Enable</v-btn>
                <v-btn v-show="(hideProductButton === true)" large block outline color="red" @click="updateProductButton('off')" :loading="loading3"
      :disabled="loading3">Disable</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-flex>



      </v-layout>

    </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
import axios from 'axios';

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  methods: {
    updateCartButton:function(option) {
      this.loading = true
      axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

      let url = 'https://' + this.$store.getters.engine + '/api/hide/cartbutton'

      axios
        .post(url,{	"option": option})
        .then(response => {
          if (option==='on') {
            this.hideCartButton = true
          } else {
            this.hideCartButton = false
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          if (error.response.status == 401) {
            this.$router.push({ path: '/login' }) 
          }
        })
        .finally(() => this.loading = false)   
    },
    updateCheckoutButton:function(option) {
      this.loading2 = true
      axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

      let url = 'https://' + this.$store.getters.engine + '/api/hide/checkoutbutton'

      axios
        .post(url,{	"option": option})
        .then(response => {
          if (option==='on') {
            this.hideCheckoutButton = true
          } else {
            this.hideCheckoutButton = false
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          if (error.response.status == 401) {
            this.$router.push({ path: '/login' }) 
          }
        })
        .finally(() => this.loading2 = false)   
    },updateProductButton:function(option) {
      this.loading3 = true
      axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

      let url = 'https://' + this.$store.getters.engine + '/api/hide/productbutton'

      axios
        .post(url,{	"option": option})
        .then(response => {
          if (option==='on') {
            this.hideProductButton = true
          } else {
            this.hideProductButton = false
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          if (error.response.status == 401) {
            this.$router.push({ path: '/login' }) 
          }
        })
        .finally(() => this.loading3 = false)   
    }
  },
  created: function () {
    console.log("created");
  },
  data () {
    return {
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      status: null,
      info: null,
      errored: false,
      hideCartButton: null,
      hideCheckoutButton: null,
      hideProductButton: null
    }
  },
  filters: {
  },
  mounted () {
      axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

      let url = 'https://' + this.$store.getters.engine + '/api/hide/status'

      axios
        .get(url)
        .then(response => {
          if (response.data['cartbutton']=='on'){
            this.hideCartButton = true
          } else {
            this.hideCartButton = false
          }
          if (response.data['checkoutbutton']=='on'){
            this.hideCheckoutButton = true
          } else {
            this.hideCheckoutButton = false
          }
          if (response.data['productbutton']=='on'){
            this.hideProductButton = true
          } else {
            this.hideProductButton = false
          }
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          if (error.response.status == 401) {
            this.$router.push({ path: '/login' }) 
          }
        })
        .finally()      
                         
        
  }
  
}
</script>
